import {
    BackupProps,
    GetCommonPayload,
    GetConfigurationPayload,
    GetInstanceMonitoringPayload,
    GetInstancePayload,
    GetInstanceLogsPayload,
    GetListInstancesPayload, GetLoadBalancerStatsPayload, GetNetworkSummary, SecurityGroupProps, GetResourceUsagesPayload
} from "../types/api-payload";
import qs from "qs";

const reactQueryKey = {
    resolveConfigurationKey: ({service_uuid, type}: GetConfigurationPayload) => {
        return `com.opennebula.org.service.${service_uuid}.configuration.${type}`;
    },

    resolvePrivateNetworksListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.private.networks.list`;
    },

    resolveReservedNetworksListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.reserved.networks.list`;
    },

    resolveLoadBalancerNetworksListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.lb.networks.list`;
    },

    resolveNetworkIncrementalKey: ({service_uuid}: GetCommonPayload) => {
        return `com.opennebula.org.service.${service_uuid}.network.incremental`;
    },

    resolveNetworkSummaryKey: ({service_uuid, network_id}: GetNetworkSummary) => {
        return `com.opennebula.org.service.${service_uuid}.networks.${network_id}.summary`;
    },

    resolveGroupPolicyKey: ({service_uuid}: GetCommonPayload) => {
        return `com.opennebula.org.service.${service_uuid}.secgroups.list`;
    },

    resolveGroupPolicyDetailKey: ({service_uuid, id}: SecurityGroupProps) => {
        return `com.opennebula.org.service.${service_uuid}.secgroups.${id}`;
    },

    resolveVolumeListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.volumes.list`;
    },

    resolveImageListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.images.list`;
    },

    resolveSnapshotListKey: ({service_uuid}: GetCommonPayload) => {
        return `com.opennebula.org.service.${service_uuid}.snapshots.list`;
    },

    resolveBackupListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.backups.list`;
    },

    resolveBackupDetailKey: ({service_uuid, backup_id}: BackupProps) => {
        return `com.opennebula.org.service.${service_uuid}.backups.${backup_id}`;
    },

    resolveInstanceSnapshotListKey: ({service_uuid, instance_id}: GetInstancePayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.${instance_id}.snapshots.list`;
    },

    resolveSSHKeyListKey: ({service_uuid}: GetCommonPayload) => {
        return `com.opennebula.org.service.${service_uuid}.sshkeys`;
    },

    resolveInstanceListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.list`;
    },

    resolveMarketplaceListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.marketplaces.list`;
    },

    resolveInstanceHealthListKey: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.health.list`;
    },

    resolveInstanceSummaryKey: ({service_uuid, instance_id}: GetInstancePayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.info.${instance_id}.summary`;
    },

    resolveInstanceDetailKey: ({service_uuid, instance_id}: GetInstancePayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.info.${instance_id}.detail`;
    },

    resolveInstanceMonitoringKey: ({service_uuid, instance_id, query}: GetInstanceMonitoringPayload) => {
        const queryString = qs.stringify(query)

        return `com.opennebula.org.service.${service_uuid}.instances.info.${instance_id}.monitoring.${queryString}`;
    },

    resolveLoadBalancerStatsKey: ({service_uuid, instance_id}: GetLoadBalancerStatsPayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.info.${instance_id}.stats`;
    },

    resolveInstanceConsoleRemoteTicketKey: ({service_uuid, instance_id}: GetInstancePayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.info.${instance_id}.vnc`;
    },

    listQuotas: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.quotas.list`;
    },

    listQuotaViewers: ({service_uuid}: GetListInstancesPayload) => {
        return `com.opennebula.org.service.${service_uuid}.quotas.viewers`;
    },

    listQuotaUsages: ({service_uuid, query}: GetResourceUsagesPayload) => {
        const queryString = qs.stringify(query, { arrayFormat: 'brackets' })

        return `com.opennebula.org.service.${service_uuid}.usages.list.${queryString}`;
    },

    resolveInstanceHealthCheckKey: ({service_uuid, instance_id}: GetInstancePayload) => {
        return `com.opennebula.org.service.${service_uuid}.instances.${instance_id}.healthz`;
    },

    resolveInstanceLogsKey: ({service_uuid, instance_id, container, lines}: GetInstanceLogsPayload) => {
        const params = new URLSearchParams();
        if (container) params.append('container', container);
        if (lines) params.append('lines', lines.toString());
        const queryString = params.toString();
        return `com.opennebula.org.service.${service_uuid}.instances.${instance_id}.logs${queryString ? `.${queryString}` : ''}`;
    },
};

export default reactQueryKey;
